<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>
  <p-confirmdialog />

  <p-card>
    <ng-template #title>
      <h1>
        {{
          isEditMode()
            ? ('catalog.additionalProducts.edit' | translate)
            : ('catalog.additionalProducts.add' | translate)
        }}
      </h1>
    </ng-template>

    <form
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      class="flex flex-col gap-4"
    >
      <div class="flex flex-col">
        <label for="ap-title" class="text-sm mb-1">
          {{ 'catalog.additionalProducts.fields.title' | translate }}
        </label>
        <input
          id="ap-title"
          pInputText
          formControlName="title"
          [maxlength]="255"
        />
        @if (form.get('title')?.touched && form.get('title')?.invalid) {
          <small class="text-red-500 mt-1">
            {{ 'validation.required' | translate }}
          </small>
        }
      </div>

      <div class="flex flex-col">
        <label for="ap-desc" class="text-sm mb-1">
          {{ 'catalog.additionalProducts.fields.description' | translate }}
        </label>
        <textarea
          id="ap-desc"
          pTextarea
          formControlName="description"
          rows="3"
        ></textarea>
      </div>

      <div class="flex flex-col">
        <label for="ap-type" class="text-sm mb-1">
          {{ 'catalog.additionalProducts.fields.type' | translate }}
        </label>
        <p-select
          inputId="ap-type"
          formControlName="type"
          [options]="typeOptions"
          optionValue="value"
          [placeholder]="
            'catalog.additionalProducts.fields.typePlaceholder' | translate
          "
          appendTo="body"
        >
          <ng-template let-opt pTemplate="item">
            {{ opt.label | translate }}
          </ng-template>
          <ng-template let-opt pTemplate="selectedItem">
            {{ opt.label | translate }}
          </ng-template>
        </p-select>
        @if (form.get('type')?.touched && form.get('type')?.invalid) {
          <small class="text-red-500 mt-1">
            {{ 'validation.required' | translate }}
          </small>
        }
      </div>

      <div class="flex justify-between items-center pt-2">
        <p-button
          type="button"
          severity="secondary"
          [label]="'label.cancel' | translate"
          (onClick)="onCancel()"
        />
        <div class="flex gap-2">
          @if (isEditMode() && model()) {
            <p-button
              type="button"
              severity="danger"
              icon="fa fa-trash"
              [label]="'label.delete' | translate"
              (onClick)="onDelete($event)"
            />
          }
          <p-button
            type="submit"
            [label]="'label.save' | translate"
            [loading]="submitting()"
          />
        </div>
      </div>
    </form>
  </p-card>

  @if (isEditMode() && ownerId() !== null) {
    <p-card>
      <app-price-history
        [owner]="{ type: 'additional_product', id: ownerId()! }"
        [prices]="prices()"
        (priceCreated)="reload()"
        (priceDeleted)="reload()"
      />
    </p-card>

    <p-card>
      <ng-template #title>
        <h2>{{ 'catalog.additionalProducts.linkedProductsSectionTitle' | translate }}</h2>
      </ng-template>
      <div class="flex flex-col gap-3">
        <label class="flex items-center gap-2">
          <p-checkbox [formControl]="$any(form.get('is_universal'))" [binary]="true" />
          <span>{{ 'catalog.additionalProducts.isUniversal' | translate }}</span>
        </label>
        <p class="text-sm text-color-secondary">
          {{ 'catalog.additionalProducts.isUniversalHint' | translate }}
        </p>
        <hr class="border-surface-200" />
        <p class="text-sm text-color-secondary">
          {{ 'catalog.additionalProducts.linkedProductsSectionHint' | translate }}
        </p>
        <p-multiSelect
          [formControl]="$any(form.get('product_ids'))"
          [options]="productService.items()"
          optionLabel="key"
          optionValue="id"
          [filter]="true"
          [showClear]="true"
          display="chip"
          appendTo="body"
          styleClass="w-full"
          [placeholder]="'catalog.additionalProducts.linkedProductsPlaceholder' | translate"
        />
      </div>
    </p-card>
  }
</div>
